<template>
  <div
    class="tw:flex tw:items-center tw:justify-between tw:w-full tw:bg-gray-100 tw:rounded-lg tw:px-3 tw:py-2 tw:md:w-auto tw:md:justify-start tw:md:gap-2 tw:md:shrink-0"
  >
    <button
      type="button"
      class="tw:flex tw:items-center tw:justify-center tw:w-6 tw:h-6 tw:border tw:border-gray-800 tw:rounded-md tw:bg-white tw:disabled:opacity-40 tw:disabled:cursor-not-allowed tw:cursor-pointer tw:hover:bg-gray-50 tw:md:order-2"
      :disabled="!canGoPrevious"
      @click="$emit('previous')"
    >
      <ChevronRight class="tw:fill-gray-800 tw:rotate-180 tw:size-5" />
    </button>

    <span class="tw:text-xs tw:whitespace-nowrap tw:md:order-1 tw:md:text-sm">{{ formattedRange }}</span>

    <button
      type="button"
      class="tw:flex tw:items-center tw:justify-center tw:w-6 tw:h-6 tw:border tw:border-gray-800 tw:rounded-md tw:bg-white tw:disabled:opacity-40 tw:disabled:cursor-not-allowed tw:cursor-pointer tw:hover:bg-gray-50 tw:md:order-3"
      :disabled="!canGoNext"
      @click="$emit('next')"
    >
      <ChevronRight class="tw:fill-gray-800 tw:size-5" />
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import ChevronRight from '@/components/icons/ChevronRight.svg?component'

import { useFormatting } from '@/composables/useFormatting'

const props = defineProps({
  startDate: {
    type: String,
    default: null,
  },
  endDate: {
    type: String,
    default: null,
  },
  canGoPrevious: {
    type: Boolean,
    default: false,
  },
  canGoNext: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['previous', 'next'])

const { formatDateRange } = useFormatting()

const formattedRange = computed(() => {
  if (!props.startDate || !props.endDate) return '-'

  return formatDateRange(props.startDate, props.endDate, { month: 'long', day: 'numeric' })
})
</script>
